import React from 'react';

export const pageMeta = {
  "name": "JS Iterables",
  "link": "/javascript/iterables"
};

export default function JavascriptIterables() {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">JS Iterables</h2>
      <p>Route: /javascript/iterables</p>
      <h3 className="mt-4 font-medium">sub_content</h3>
      <pre>{JSON.stringify(pageMeta, null, 2)}</pre>
    </div>
  );
}
